import type { OptionsMap } from '@openx/types/options.ts';
import { useCallback, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import type { AnyAction } from 'redux';
import { arrayContainsArray } from '../lib/arrayContainsArray.ts';
import { loadBrandsOptions, searchBrands } from '../state/brands/brandsSearch/dispatchers.ts';
import type { BaseState } from '../state/brands/brandsSearch/reducer.ts';

interface StateProps {
  isLoading: boolean;
  brands: OptionsMap;
  fetchedIds: string[];
}

//TODO: UIG-540 Review this type definition ids: (string | null)[] = []?
export function useBrandsFetch(ids: (string | null)[] = []) {
  const dispatch = useDispatch();

  const { isLoading, brands, fetchedIds } = useSelector<BaseState, StateProps>(
    state => ({
      brands: state.brands.brandsSearch.options,
      fetchedIds: state.brands.brandsSearch.fetchedOptionsIds,
      isLoading: state.brands.brandsSearch.searchLoading || state.brands.brandsSearch.optionsLoading,
    }),
    shallowEqual
  );

  const idsToFetch = ids.filter(id => id !== null) as string[];

  // biome-ignore lint/correctness/useExhaustiveDependencies: needed here?
  useEffect(() => {
    dispatch(loadBrandsOptions(idsToFetch) as unknown as AnyAction);
  }, [dispatch, JSON.stringify(ids)]);

  const refetchBrands = useCallback(
    (brandName: string) => {
      dispatch(searchBrands(brandName) as unknown as AnyAction);
    },
    [dispatch]
  );

  if (idsToFetch.length && !arrayContainsArray(fetchedIds, idsToFetch)) {
    return {
      brands: {},
      isBrandsLoading: true,
      refetchBrands,
    };
  }

  return {
    brands,
    isBrandsLoading: isLoading,
    refetchBrands,
  };
}
